import { useCallback, useState } from 'react'
import { toast } from '@sales-center/components'
import { BillToMatchDrawerProps } from '../typings'
import { selectBillToCreator } from '../../hooks'

export function useActions(params: BillToMatchDrawerProps) {
  const { state, dispatch, onClose } = params

  const [billTo, setBillTo] = useState(state.externalBillTo)

  const onSave = useCallback(() => {
    if (!!billTo) {
      dispatch(selectBillToCreator(billTo))
      onClose()
    } else {
      toast.error('Select a Bill-to to match')
    }
  }, [billTo, dispatch, onClose])

  return {
    onSave,
    billTo,
    setBillTo,
  }
}
